import { createAction } from 'typesafe-actions';
import { takeLatest, put, call } from 'redux-saga/effects';
import { Breadcrumb } from 'types/page-model';
import { selectBreadcrumbs } from 'features/page-model/ducks/get-model';
import { RELATED_PRODUCT_ITEM_IN_VIEWPORT } from 'features/related-products/ducks';
import { getPrimaryPriceCb, getProductBelongFromSource } from 'features/product-info';
import { selectProductDiscount, selectProductPricePrevious } from '../selectors';

export const sendImpressions = createAction(
  'GA:impressions',
  (data: {
    elementBlock: string;
    productName: string;
    productId: string;
    productPrice: string;
    productPrevPrice: string | null;
    productDiscount: number | null;
    productPosition: string;
    productBelong: string;
    division: string;
    subdivision: string;
  }) => ({
    ...data,
    elementType: 'product',
  }),
)();

export function* runGaImpressionsDetector() {
  const gaImpressionsReceivedIds = new Set<string>();

  yield takeLatest(RELATED_PRODUCT_ITEM_IN_VIEWPORT, function* putGaImpressions({ payload }) {
    const { product } = payload;

    if (!gaImpressionsReceivedIds.has(createSetKey())) {
      gaImpressionsReceivedIds.add(createSetKey());
      const breadcrumbs = (yield call(selectBreadcrumbs)) as Breadcrumb[];
      const division = breadcrumbs[2]?.label || '';
      const subdivision = breadcrumbs[3]?.label || '';

      yield put(
        sendImpressions({
          elementBlock: payload.productListId ? payload.productListId : 'productList',
          productName: product.displayedName,
          productId: product.productId,
          productPrice: String(getPrimaryPriceCb(product.price).price),
          productPrevPrice: yield call(selectProductPricePrevious),
          productDiscount: yield call(selectProductDiscount),
          productPosition: String(payload.productPositionFromOne),
          productBelong: getProductBelongFromSource(payload.product.source),
          division,
          subdivision,
        }),
      );
    }

    function createSetKey() {
      return `${payload.productListId}:${product.productId}`;
    }
  });
}
